import React, { FC } from 'react';
import classNames from 'classnames';
import classes from './styles/index.module.scss';
import { useTranslationAPI } from '../../modules/translations';
import { isNullOrUndefined } from '../../predicates/type';
import { codes } from '../../data/translations';
import { RouteLink } from '../RouteLink';

export const HELLOFLEX_PREVIEW_VALUE_CLASS = 'helloflex-preview-value';

export type PreviewValueProps = {
	hasBottomLine: boolean;
	breakWord: boolean;
	textEllipsis: boolean;
	placeholder: string;
	previewUrl: string;
	previewValueClassName?: string;
	style?: React.CSSProperties;
	title?: string;
};

const PreviewValue: FC<React.PropsWithChildren<Partial<PreviewValueProps>>> = ({
	children,
	hasBottomLine = true,
	breakWord,
	textEllipsis,
	previewUrl,
	previewValueClassName,
	style,
	title,
}) => {
	const { translate } = useTranslationAPI();
	const valueClasses = classNames(
		HELLOFLEX_PREVIEW_VALUE_CLASS,
		classes.value,
		{
			[classes.value_hasBottomLine]: hasBottomLine,
			[classes.value_wrapText]: breakWord,
			[classes.value_textEllipsis]: textEllipsis,
		},
		previewValueClassName,
	);

	if (isNullOrUndefined(children) || (typeof children === 'string' && children.length === 0)) {
		// const previewPlaceholder = isNullOrUndefined(placeholder) ? translate(codes.common.empty) : placeholder;

		return (
			<div
				style={style}
				className={valueClasses}
			>
				<span className={classes.placeholder}>{translate(codes.common.empty)}</span>
			</div>
		);
	}

	if (previewUrl) {
		return (
			<div
				style={style}
				className={valueClasses}
			>
				<RouteLink href={previewUrl}>{children}</RouteLink>
			</div>
		);
	}

	return (
		<div
			style={style}
			className={valueClasses}
			title={title}
		>
			{children}
		</div>
	);
};

export { PreviewValue };
